import { C11ReverseRowStoriesProps } from './C11ReverseRowStories.types';
import { REVERSE_ROW_STORIES_CONTAINER } from 'src/shared/static';
import { ReverseRowsProps } from '@ahc-digital/component-library';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { getCheckbox, getDroplink } from 'src/shared/param-utils';
import { Placeholder } from '@sitecore-jss/sitecore-jss-nextjs';

export function CreateReverseRowStoriesModel(props?: C11ReverseRowStoriesProps) {
  type t = ReverseRowsProps;
  const { rendering, params, fields } = props || {};
  const { renderRichText, renderLink, renderText } = useConditionalRendering();

  const removePaddingBetweenRows = props?.params?.RemovePaddingBetweenRows;
  return {
    headline: renderText(fields?.Headline),
    headlineTag: getDroplink<t['headlineTag']>(params?.HeadlineTag, 'h2'),
    supportCopy: renderRichText(fields?.SupportCopy),
    supportCopyBottom: renderRichText(fields?.SupportCopyBottom),
    cta: renderLink(fields?.CTA),
    ctaStyle: getDroplink(params?.CtaStyle, 'link'),
    rows: rendering && <Placeholder name={REVERSE_ROW_STORIES_CONTAINER} rendering={rendering} />,
    shouldRemovePaddingBetweenRows: !!removePaddingBetweenRows,
    shouldLazyLoad: getCheckbox(params?.ShouldLazyLoad),
  };
}
